var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "newQianniuExam" } },
    [
      !_vm.isHaveBadge
        ? [
            _c("p", { attrs: { align: "center" } }, [
              _vm._v("您还没有获得在线上岗徽章！")
            ])
          ]
        : [
            _c("div", { staticClass: "el-tabs el-tabs--left" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "el-tabs__content" }, [
                _c(
                  "div",
                  {
                    staticClass: "el-tab-pane",
                    attrs: { id: "tab-first-content" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "stoptip",
                        attrs: { id: "stoptip-first" }
                      },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始实操练习")]
                            )
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "content",
                        attrs: { id: "content-first" }
                      },
                      [
                        _c("div", { staticClass: "con-left" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isShowQnIcon,
                                  expression: "isShowQnIcon"
                                }
                              ],
                              staticClass: "qnbox"
                            },
                            [
                              _c("img", {
                                staticClass: "qnbg",
                                attrs: {
                                  src: require("@/assets/images/doubleQianNiu/qnbg.jpg")
                                }
                              }),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "qnicon01",
                                attrs: {
                                  src: require("@/assets/images/doubleQianNiu/qnicon01.png")
                                },
                                on: { click: _vm.showLoginImg }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isShowQnIcon2,
                                  expression: "isShowQnIcon2"
                                }
                              ],
                              staticClass: "qnbox"
                            },
                            [
                              _c("img", {
                                staticClass: "qnbg",
                                attrs: {
                                  src: require("@/assets/images/doubleQianNiu/qnbg.jpg")
                                }
                              }),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "qnicon02",
                                attrs: {
                                  src: require("@/assets/images/doubleQianNiu/qnicon02.png")
                                },
                                on: { dblclick: _vm.showLoginImg2 }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isShowLoginImg,
                                  expression: "isShowLoginImg"
                                }
                              ],
                              staticClass: "login"
                            },
                            [
                              _c("img", {
                                staticClass: "homeImg",
                                attrs: {
                                  src: require("@/assets/images/doubleQianNiu/login.jpg")
                                }
                              }),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.name,
                                    expression: "name"
                                  }
                                ],
                                staticClass: "name",
                                attrs: {
                                  type: "text",
                                  placeholder: "请输入账号"
                                },
                                domProps: { value: _vm.name },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.name = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.password,
                                    expression: "password"
                                  }
                                ],
                                staticClass: "password",
                                attrs: {
                                  type: "password",
                                  autocomplete: "new-password",
                                  placeholder: "请输入密码"
                                },
                                domProps: { value: _vm.password },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.password = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "logIn",
                                on: { click: _vm.loginIn }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isShowRnd,
                                  expression: "isShowRnd"
                                }
                              ],
                              staticClass: "loginrnd"
                            },
                            [
                              _c("img", {
                                staticClass: "rndImg",
                                attrs: {
                                  src: require("@/assets/images/doubleQianNiu/loginrnd.jpg")
                                }
                              }),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.rnd,
                                    expression: "rnd"
                                  }
                                ],
                                staticClass: "rnd",
                                attrs: {
                                  type: "text",
                                  placeholder: "请输入短信验证码"
                                },
                                domProps: { value: _vm.rnd },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.rnd = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "logInRnd",
                                on: { click: _vm.loginInRnd }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isShowLoginIndex,
                                  expression: "isShowLoginIndex"
                                }
                              ],
                              staticClass: "jdbox"
                            },
                            [
                              _c("img", {
                                staticClass: "jdimg",
                                attrs: {
                                  src: require("@/assets/images/doubleQianNiu/jdicon.jpg")
                                }
                              })
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "con-right" },
                          [
                            _vm._m(1),
                            _vm._v(" "),
                            _vm.isShowQnIcon || _vm.isShowQnIcon2
                              ? _c("p", [
                                  _vm._v("请点击"),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "red",
                                        "font-weight": "bold"
                                      }
                                    },
                                    [_vm._v("左侧练习场")]
                                  ),
                                  _vm._v("中的千牛图标进行登录")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isShowLoginImg ||
                            _vm.isShowRnd ||
                            _vm.isShowLoginIndex
                              ? [
                                  _c("p", [_vm._v("① 账号密码由项目主管提供")]),
                                  _vm._v(" "),
                                  _c("p", [_vm._v("② 验证码15分钟内有效")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v("③ 如果是新账号，需要绑定自己的信息")
                                  ])
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "stoptip",
                        attrs: { id: "studytip-first" }
                      },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [_vm._v("实操通关，进入下一关吧")]),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: {
                                  click: function($event) {
                                    return _vm.studyNext(
                                      "#tab-second",
                                      2,
                                      "second"
                                    )
                                  }
                                }
                              },
                              [_vm._v("GO，下一关")]
                            )
                          ])
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "el-tab-pane",
                    class: { mynone: _vm.tabCurrent !== "second" },
                    attrs: { id: "tab-second-content" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "stoptip",
                        attrs: { id: "stoptip-second" }
                      },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始实操练习")]
                            )
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "content",
                        attrs: { id: "content-second" }
                      },
                      [
                        _c("div", { staticClass: "con-left" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isShowWgq,
                                  expression: "!isShowWgq"
                                }
                              ],
                              staticClass: "gqbox"
                            },
                            [
                              _c("img", {
                                staticClass: "gqimg",
                                attrs: {
                                  src: require("@/assets/images/doubleQianNiu/gq.jpg")
                                }
                              }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "gqbtn",
                                on: {
                                  click: function($event) {
                                    _vm.showGqImg = true
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("img", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showGqImg,
                                    expression: "showGqImg"
                                  }
                                ],
                                staticClass: "qhimg",
                                attrs: {
                                  src: require("@/assets/images/doubleQianNiu/qh.png")
                                }
                              }),
                              _vm._v(" "),
                              _c("div", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showGqImg,
                                    expression: "showGqImg"
                                  }
                                ],
                                staticClass: "gqclick",
                                on: { click: _vm.showWgqImg }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "wgqbox" }, [
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isShowWgq,
                                  expression: "isShowWgq"
                                }
                              ],
                              staticClass: "wgqimg",
                              attrs: {
                                src: require("@/assets/images/doubleQianNiu/wgq.jpg")
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._m(2)
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "stoptip",
                        attrs: { id: "studytip-second" }
                      },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [_vm._v("实操通关，进入下一关吧")]),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: {
                                  click: function($event) {
                                    return _vm.studyNext(
                                      "#tab-third",
                                      3,
                                      "third"
                                    )
                                  }
                                }
                              },
                              [_vm._v("GO，下一关")]
                            )
                          ])
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "el-tab-pane",
                    class: { mynone: _vm.tabCurrent !== "third" },
                    attrs: { id: "tab-third-content" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "stoptip",
                        attrs: { id: "stoptip-third" }
                      },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始实操练习")]
                            )
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "content",
                        attrs: { id: "content-third" }
                      },
                      [
                        _c("div", { staticClass: "con-left" }, [
                          _c("div", { staticClass: "kjdybox" }, [
                            _vm.isShowKjdy01
                              ? _c("div", { staticClass: "kjdy" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/images/doubleQianNiu/kjdy01.jpg")
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "kjdy04icon",
                                    on: { click: _vm.showKjdy01 }
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isShowKjdy02
                              ? _c("div", { staticClass: "kjdy" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/images/doubleQianNiu/kjdy02.jpg")
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "kjdy06icon" }, [
                                    _c("input", {
                                      staticClass: "btn-file",
                                      attrs: { type: "file" },
                                      on: {
                                        change: function($event) {
                                          return _vm.tirggerFile($event)
                                        }
                                      }
                                    })
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isShowKjdy03
                              ? _c("div", { staticClass: "kjdy" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/images/doubleQianNiu/kjdy03.jpg")
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "kjdy07icon",
                                    on: { click: _vm.showKjdy02 }
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isShowKjdy04
                              ? _c("div", { staticClass: "kjdy" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/images/doubleQianNiu/kjdy04.jpg")
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "kjdy08icon",
                                    on: { click: _vm.showKjdy03 }
                                  })
                                ])
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "con-right" }, [
                          _vm._m(3),
                          _vm._v(" "),
                          _vm.isShowKjdyTip01
                            ? _c("div", [
                                _c("p", [_vm._v("请将快捷短语导入。")])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isShowKjdyTip02
                            ? _c("div", [
                                _c("p", [_vm._v("请将快捷短语导出。")])
                              ])
                            : _vm._e()
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "stoptip",
                        attrs: { id: "studytip-third" }
                      },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [_vm._v("实操通关，进入下一关吧")]),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: {
                                  click: function($event) {
                                    return _vm.studyNext("#tab-four", 4, "four")
                                  }
                                }
                              },
                              [_vm._v("GO，下一关")]
                            )
                          ])
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "el-tab-pane",
                    class: { mynone: _vm.tabCurrent !== "four" },
                    attrs: { id: "tab-four-content" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "stoptip", attrs: { id: "stoptip-four" } },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始实操练习")]
                            )
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "content", attrs: { id: "content-four" } },
                      [
                        _c("div", { staticClass: "con-left" }, [
                          _c("div", { staticClass: "kjdybox" }, [
                            _vm.isShowKjdy05
                              ? _c("div", { staticClass: "kjdy" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/images/doubleQianNiu/kjdy05.jpg")
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "kjdy09icon",
                                    on: { click: _vm.showKjdy04 }
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isShowKjdy06
                              ? _c("div", { staticClass: "kjdy" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/images/doubleQianNiu/kjdy06.jpg")
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "focus",
                                        rawName: "v-focus",
                                        value: true,
                                        expression: "true"
                                      }
                                    ],
                                    staticClass: "kjdy09input",
                                    attrs: { type: "text" },
                                    on: {
                                      keyup: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.showKjdy05.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "kjdy03icon",
                                    on: { click: _vm.showKjdy05 }
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isShowKjdy07
                              ? _c("div", { staticClass: "kjdy" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/images/doubleQianNiu/kjdy07.jpg")
                                    }
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isShowKjdy08
                              ? _c(
                                  "div",
                                  { staticClass: "kjdy" },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/images/doubleQianNiu/kjdy08.jpg")
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      staticClass: "kjdytextarea",
                                      attrs: { type: "textarea" },
                                      model: {
                                        value: _vm.kjdy,
                                        callback: function($$v) {
                                          _vm.kjdy = $$v
                                        },
                                        expression: "kjdy"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "kjdy03icon",
                                      on: { click: _vm.showKjdy06 }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isShowKjdy09
                              ? _c("div", { staticClass: "kjdy" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/images/doubleQianNiu/kjdy09.jpg")
                                    }
                                  })
                                ])
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "con-right" }, [
                          _vm._m(4),
                          _vm._v(" "),
                          _vm.isShowKjdyTip03
                            ? _c("div", [
                                _c("p", [_vm._v("使用快捷短语回复")]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "每个店铺对于响应时间的要求不同，首响一般是15秒，平响30秒，越短越好哦"
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isShowKjdyTip04
                            ? _c("div", [
                                _c("p", [
                                  _vm._v(
                                    "请手动回复“您好，请问您的收货地址是哪里？”"
                                  )
                                ])
                              ])
                            : _vm._e()
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "stoptip",
                        attrs: { id: "studytip-four" }
                      },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [_vm._v("实操通关，进入下一关吧")]),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: {
                                  click: function($event) {
                                    return _vm.studyNext("#tab-five", 5, "five")
                                  }
                                }
                              },
                              [_vm._v("GO，下一关")]
                            )
                          ])
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "el-tab-pane",
                    class: { mynone: _vm.tabCurrent !== "five" },
                    attrs: { id: "tab-five-content" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "stoptip", attrs: { id: "stoptip-five" } },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始实操练习")]
                            )
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "content", attrs: { id: "content-five" } },
                      [
                        _c("div", { staticClass: "con-left" }, [
                          _c("div", { staticClass: "zjgnbox" }, [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isShowZjgnicon,
                                    expression: "isShowZjgnicon"
                                  }
                                ],
                                staticClass: "zjgn"
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/images/doubleQianNiu/zjgn.jpg")
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-input", {
                                  staticClass: "zjgntextarea",
                                  attrs: { type: "textarea" },
                                  model: {
                                    value: _vm.zjcz,
                                    callback: function($$v) {
                                      _vm.zjcz = $$v
                                    },
                                    expression: "zjcz"
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "zjgnsend",
                                  on: { click: _vm.showZjgn01 }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isShowZjgn01,
                                    expression: "isShowZjgn01"
                                  }
                                ],
                                staticClass: "zjgn"
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/images/doubleQianNiu/zjgn01.jpg")
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "zjgnicon",
                                  on: { click: _vm.showZjgn02 }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isShowZjgn02,
                                    expression: "isShowZjgn02"
                                  }
                                ],
                                staticClass: "zjgn"
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/images/doubleQianNiu/zjgn02.jpg")
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "zjgn01icon",
                                  on: { mouseover: _vm.showZjgn03 }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isShowZjgn03,
                                    expression: "isShowZjgn03"
                                  }
                                ],
                                staticClass: "zjgn"
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/images/doubleQianNiu/zjgn03.jpg")
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "zjgn03icon",
                                  on: { mouseover: _vm.showZjgn04 }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isShowZjgn04,
                                    expression: "isShowZjgn04"
                                  }
                                ],
                                staticClass: "zjgn"
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/images/doubleQianNiu/zjgn04.jpg")
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "zjgn04icon",
                                  on: { click: _vm.showZjgn05 }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isShowZjgn05,
                                    expression: "isShowZjgn05"
                                  }
                                ],
                                staticClass: "zjgn"
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/images/doubleQianNiu/zjgn05.jpg")
                                  }
                                })
                              ]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "con-right" }, [
                          _vm._m(5),
                          _vm._v(" "),
                          _vm.isShowZjgnTip01
                            ? _c("p", [
                                _vm._v(
                                  "手动回复“抱歉给您带来了不好的体验，这边给您转接售后客服”"
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isShowZjgnTip02
                            ? _c("p", [
                                _vm._v(
                                  "转接功能操作练习：请将“客户002”转接给“小红（贝拉）”"
                                )
                              ])
                            : _vm._e()
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "stoptip",
                        attrs: { id: "studytip-five" }
                      },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [_vm._v("实操通关，进入下一关吧")]),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: {
                                  click: function($event) {
                                    return _vm.studyNext("#tab-six", 6, "six")
                                  }
                                }
                              },
                              [_vm._v("GO，下一关")]
                            )
                          ])
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "el-tab-pane",
                    class: { mynone: _vm.tabCurrent !== "six" },
                    attrs: { id: "tab-six-content" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "stoptip", attrs: { id: "stoptip-six" } },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始实操练习")]
                            )
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "content", attrs: { id: "content-six" } },
                      [
                        _c("div", { staticClass: "con-left" }, [
                          _c("div", { staticClass: "ddcjbox" }, [
                            _vm.isShowDdcjicon
                              ? _c("div", { staticClass: "ddcj" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/images/doubleQianNiu/ddcj.jpg")
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "ddcjicon",
                                    on: { click: _vm.showDdcj01 }
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isShowDdcj01
                              ? _c(
                                  "div",
                                  { staticClass: "ddcj" },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/images/doubleQianNiu/ddcj01.jpg")
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      staticClass: "ddcj01input",
                                      attrs: {
                                        type: "textarea",
                                        placeholder: "请填写备注"
                                      },
                                      model: {
                                        value: _vm.ddcjbz,
                                        callback: function($$v) {
                                          _vm.ddcjbz = $$v
                                        },
                                        expression: "ddcjbz"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "ddcj01icon",
                                      on: { click: _vm.showDdcj02 }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isShowDdcj02
                              ? _c("div", { staticClass: "ddcj" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/images/doubleQianNiu/ddcj02.jpg")
                                    }
                                  })
                                ])
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._m(6)
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "stoptip", attrs: { id: "studytip-six" } },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [_vm._v("实操通关，进入下一关吧")]),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: {
                                  click: function($event) {
                                    return _vm.studyNext(
                                      "#tab-seven",
                                      7,
                                      "seven"
                                    )
                                  }
                                }
                              },
                              [_vm._v("GO，下一关")]
                            )
                          ])
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "el-tab-pane",
                    class: { mynone: _vm.tabCurrent !== "seven" },
                    attrs: { id: "tab-seven-content" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "stoptip",
                        attrs: { id: "stoptip-seven" }
                      },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始实操练习")]
                            )
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "content",
                        attrs: { id: "content-seven" }
                      },
                      [
                        _c("div", { staticClass: "con-left" }, [
                          _c("div", { staticClass: "kjdybox" }, [
                            _vm.isShowEnd01
                              ? _c(
                                  "div",
                                  { staticClass: "kjdy" },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/images/doubleQianNiu/end01.jpg")
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      staticClass: "kjdytextarea",
                                      attrs: { type: "textarea" },
                                      model: {
                                        value: _vm.end,
                                        callback: function($$v) {
                                          _vm.end = $$v
                                        },
                                        expression: "end"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "kjdy03icon",
                                      on: { click: _vm.showEnd01 }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isShowEnd02
                              ? _c("div", { staticClass: "kjdy" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/images/doubleQianNiu/end02.jpg")
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "kjdy10icon",
                                    on: { click: _vm.showEnd02 }
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isShowEnd03
                              ? _c("div", { staticClass: "kjdy" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/images/doubleQianNiu/end03.jpg")
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "focus",
                                        rawName: "v-focus",
                                        value: true,
                                        expression: "true"
                                      }
                                    ],
                                    staticClass: "kjdy09input",
                                    attrs: { type: "text" },
                                    on: {
                                      keyup: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.showEnd03.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "kjdy03icon",
                                    on: { click: _vm.showEnd03 }
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isShowEnd04
                              ? _c("div", { staticClass: "kjdy" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/images/doubleQianNiu/end04.jpg")
                                    }
                                  })
                                ])
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._m(7)
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "stoptip",
                        attrs: { id: "studytip-seven" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "tip",
                            staticStyle: { width: "400px", height: "310px" }
                          },
                          [
                            _c("span", { staticClass: "el-icon-success" }),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticStyle: { "padding-bottom": "5px" } },
                              [
                                _vm._v(
                                  _vm._s(_vm.tjkName) +
                                    "（" +
                                    _vm._s(_vm.tjkNumber) +
                                    "），恭喜您！"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("p", { staticStyle: { padding: "5px 0" } }, [
                              _vm._v("通过【双11&618徽章】培训-实操演练！")
                            ]),
                            _vm._v(" "),
                            _c("p", { staticStyle: { padding: "5px 0" } }, [
                              _vm._v("快快截图此页面去提交作业吧！")
                            ]),
                            _vm._v(" "),
                            _c("p", { staticStyle: { padding: "5px 0" } }, [
                              _vm._v("如果想再次练习可以点击再来一遍！")
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticStyle: { "padding-top": "5px" } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.again }
                                  },
                                  [_vm._v("再来一遍")]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ])
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "el-tabs__header is-left" }, [
      _c("div", { staticClass: "el-tabs__nav-wrap is-left" }, [
        _c("div", { staticClass: "el-tabs__nav-scroll" }, [
          _c("div", { staticClass: "el-tabs__nav is-left" }, [
            _c("div", {
              staticClass: "el-tabs__active-bar is-left",
              staticStyle: { height: "50px", transform: "translateY(0px)" }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left is-active",
                attrs: { id: "tab-first" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("1、登录千牛工作台")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-second" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("2、切换状态")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-third" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("3、快捷短语导入导出")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-four" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("4、快捷短语+开头语")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-five" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("5、转接功能")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-six" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("6、备注")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-seven" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("7、结束语+快捷短语")
                  ])
                ])
              ]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "con-right" }, [
      _c("h3", [
        _c("span", { staticClass: "line" }),
        _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("① 挂起=不接待客户，不能随意挂起！！！")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("② 下班时间到点后，才能挂起，挂起之后需接待完手上的客户")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t              提示\n\t            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "con-right" }, [
      _c("h3", [
        _c("span", { staticClass: "line" }),
        _vm._v("\n\t              提示\n\t            ")
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("添加备注")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "con-right" }, [
      _c("h3", [
        _c("span", { staticClass: "line" }),
        _vm._v("\n\t              提示\n\t            ")
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("① 结束语是必须要有的哦！")]),
      _vm._v(" "),
      _c("p", [_vm._v("② 聊天记录的最后一句一定是要客服回复的！")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("③ 另外还要关注问答比，问答比是客户跟客服的对话各占的比率！")
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("如果话术过长，可以适当拆分进行发送")]),
      _vm._v(" "),
      _c("p", [_vm._v("不能为了问答比拆封一整句话，形成一句不完整的话")]),
      _vm._v(" "),
      _c("p", [_vm._v("只要是能够逻辑清晰，正常表达的，就可以适当的拆分")]),
      _vm._v(" "),
      _c("p", [_vm._v("stepA、提示：手动回复“还有其他的可以帮您吗？”")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "stepB、提示：发送快捷短语。好的亲，祝您购物愉快，有其他问题可以咨询我哦~小金随时为您服务！"
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-290c004f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-290c004f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/simulate/doubleQianNiuExam.vue
// module id = 1405
// module chunks = 0